@if (!loading) {
  <!-- MOTO Payment Dialog -->
  <sps-moto-payment-dialog [visible]="showVirtualTerminal"
                           [projectId]="paymentData?.projectId"
                           [tenantId]="paymentData?.tenantId"
                           [paymentTypeStatus]="paymentData.status"
                           [paymentTypeTitle]="paymentData.title"
                           [showTestHint]="false"
                           [showBackButton]="true"
                           (cancelled)="closeMotoDialog()"
                           (closed)="closeMotoDialog()">
  </sps-moto-payment-dialog>
  <!-- edit Payment Type Dialog -->
  <p-dialog [header]="i18n?.i18nLng()[editPaymentDialog?.i18nTitleKey]"
            [modal]="true"
            [(visible)]="editPaymentDialog.visible"
            [style]="{width: '50rem'}"
            [closable]="true"
            [resizable]="false"
            [draggable]="false">
    @switch (editPaymentDialog.type) {
      @case (PaymentDialogType.PAYMENTTYPE) {
        <edit-form-payment-type [paymentData]="paymentData" [paymentInvalidFlags]="paymentInvalidFlags" [customerGroup]="authService.organisationData.customerGroup"></edit-form-payment-type>
      }
      @case (PaymentDialogType.BANKACCOUNT) {
        <edit-form-bank-account [paymentData]="paymentData" [paymentInvalidFlags]="paymentInvalidFlags" (ibanValidated)="onIbanValidated($event)"></edit-form-bank-account>
      }
      @case (PaymentDialogType.EMAILNOTIFICATION) {
        <edit-form-email-notification [paymentData]="paymentData" [paymentInvalidFlags]="paymentInvalidFlags"></edit-form-email-notification>
      }
    }
    <ng-template #footer>
      <div class="flex w-full align-items-center justify-content-between">
        <div class="text-sm">
          @if ((editPaymentDialog.type !== PaymentDialogType.BANKACCOUNT) || paymentData.status === 'LIVE') {
            <sup class="sps-sup">*</sup><span><i>{{ i18n.i18nLng()['REQUIREDHELP'] }}</i></span>
          }
        </div>
        <div class="flex gap-2">
          <p-button [label]="i18n.i18nLng()['CANCEL']" severity="secondary" (click)="cancelEditPaymentData()"/>
          <p-button [label]="i18n.i18nLng()['SAVE']" (onClick)="savePaymentData()"/>
        </div>
      </div>
    </ng-template>
  </p-dialog>
  <div class="grid">
    <div class="col-12 xl:col-6">
      <sps-payment-method-data-card [title]="i18n.i18nLng()['PAYMENTTYPETITLE']"
                                    [editable]="paymentData?.status !== 'CLOSED'"
                                    titleColumnWidth="200px"
                                    [tableData]="tableDataPaymentType"
                                    (onEdit)="showEditDialog(PaymentDialogType.PAYMENTTYPE)">
      </sps-payment-method-data-card>
    </div>
    <div class="col-12 xl:col-6">
      <!-- could not be edited anymore -> should now be changed in admin portal -->
      <sps-payment-method-data-card [title]="i18n.i18nLng()['PAYOUTDETAILS']"
                                    [editable]="false"
                                    titleColumnWidth="200px"
                                    [tableData]="tableDataBankAccount"
                                    (onEdit)="showEditDialog(PaymentDialogType.BANKACCOUNT)">
      </sps-payment-method-data-card>
    </div>
    <div class="col-12 xl:col-6">
      <sps-payment-method-data-card [title]="i18n.i18nLng()['TECHSPECS']"
                                    [editable]="false"
                                    titleColumnWidth="200px"
                                    [tableData]="tableDataShopIntegration">
      </sps-payment-method-data-card>
    </div>
    <div class="col-12 xl:col-6">
      <sps-payment-method-data-card [title]="i18n.i18nLng()['EMAILNOTIFICATION']"
                                    [editable]="paymentData?.status !== 'CLOSED'"
                                    titleColumnWidth="200px"
                                    [tableData]="tableDataEmailNotification"
                                    (onEdit)="showEditDialog(PaymentDialogType.EMAILNOTIFICATION)">
      </sps-payment-method-data-card>
    </div>
    @if (paymentData.paymentMethod === PaymentMethodName.CREDITCARD_MOTO) {
      <div class="col-12 xl:col-6">
        <p-card class="h-full">
          <ng-template pTemplate="title">
            <div class="flex flex-1 align-items-center gap-2">
              <div class="flex-1">{{ i18n.i18nLng()['CREDITCARD_MOTO_PAY'] }}</div>
            </div>
          </ng-template>
          <div class="mb-3 line-height-3">
            {{ i18n.i18nLng()['CREDITCARD_MOTO_TITLE'] }}
          </div>
          <p-button class="mt-3"
                    icon="pi pi-credit-card"
                    [outlined]="true"
                    [label]="i18n.i18nLng()['VIRTUALTERMINAL']"
                    (onClick)="showMotoDialog()"/>
        </p-card>
      </div>
    }
  </div>
}
